export default __webpack_public_path__ + "images/WJ.ea19542.png";